<template>
  <div class="d-flex flex-column pb-2">
    <h5>Select a portfolio</h5>

    <p class="text-muted">
      All the products in the current results will be added to the selected portfolio. You can add additional products or remove any of them later.
    </p>

    <div class="my-1">
      <b-form-radio
        v-model="selectedPortfolio"
        name="portfolio"
        :value="-1"
        :disabled="!canCreatePortfolio"
        class="pb-2"
      >
        Create New Portfolio

        <feather-icon
          v-if="!canCreatePortfolio"
          icon="LockIcon"
          size="14"
          class="ml-50"
        />
      </b-form-radio>

      <p
        v-if="!canCreatePortfolio"
        class="text-muted small ml-2"
      >
        You have reached your limit of having {{ portfolioMax }} portfolios.
      </p>

      <b-form-radio
        v-for="portfolio in portfolios"
        :key="portfolio.portfolioId"
        v-model="selectedPortfolio"
        name="portfolio"
        :value="portfolio.portfolioId"
        class="pb-0-5"
      >
        {{ portfolio.portfolioName }}
      </b-form-radio>
    </div>

    <BButton
      variant="primary"
      class="d-flex justify-content-center"
      :disabled="loading || !selectedPortfolio || (selectedPortfolio === -1 && !canCreatePortfolio)"
      @click.prevent="selectedPortfolio === -1 ? $emit('create-portfolio') : addProductsToPortfolio()"
    >
      Add To Portfolio
      <b-spinner
        v-if="loading === 1"
        class="ml-1 align-self-center"
        small="true"
      />
    </BButton>

    <span class="d-block text-center small mb-1" />

    <BButton
      variant="primary"
      class="d-flex justify-content-center"
      :disabled="loading || !selectedPortfolio || (selectedPortfolio === -1 && !canCreatePortfolio)"
      @click.prevent="selectedPortfolio === -1 ? $emit('create-portfolio', true) : addProductsToPortfolio(true)"
    >
      Add To Portfolio and View Portfolio
      <b-spinner
        v-if="loading === 2"
        class="ml-1 align-self-center"
        small="true"
      />
    </BButton>
  </div>
</template>

<script>
import {
  BFormRadio,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import strings from '@/strings'
import { mapGetters } from 'vuex'

export default {
  components: {
    BFormRadio,
    BButton,
    BSpinner,
  },
  props: {
    portfolios: {
      type: Array,
      required: true,
    },
    searchFilter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedPortfolio: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'portfolioMax',
      'portfolioMaxProducts',
    ]),
    canCreatePortfolio() {
      return this.portfolioMax === 0
        || this.portfolios.length < this.portfolioMax
    },
    maxNumberOfProductsInPortfolio() {
      return this.portfolioMaxProducts
    },
  },
  methods: {
    addProductsToPortfolio(viewPortfolio = false) {
      this.loading = viewPortfolio ? 2 : 1

      this.$http.post('lifecycle/public/portfolio.cfc?method=addProductsToPortfolio', new URLSearchParams({
        portfolioId: this.selectedPortfolio,
        searchFilter: JSON.stringify(this.searchFilter),
      }))
        .then(() => {
          this.$emit('products-added', {
            portfolioId: this.selectedPortfolio,
            viewPortfolio,
          })
          this.selectedPortfolio = null
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            this.$bvToast.toast('Portfolio Product Limit Reached', {
              title: strings.defaultErrorTitle,
              variant: 'danger',
              solid: true,
            })
          } else {
            this.$bvToast.toast(strings.defaultErrorMessage, {
              title: strings.defaultErrorTitle,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.pb-0-5 {
  padding-bottom: 6px;
}
</style>
